import { createReducer } from 'redux-act';
import { ISlideshow } from 'old-store/types/slideshowsCollections';
import { fetchSlideshowsSuccess } from 'old-store/actions';

const initialState: Partial<ISlideshow[]> = [];

export const slideshowsCollections = createReducer({}, initialState);
slideshowsCollections.on(fetchSlideshowsSuccess, (state, payload) => payload);
